
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User, Info, Device, Message, DeviceEvent} from '@/types/core';

import VueError from '@/components/VueError.vue';
import Loading from '@/components/Loading.vue';
import LoraWanUpdateView from '@/components/LoraWanUpdateView.vue';
import CustomSectionHeader from '@/components/CustomSectionHeader.vue';
import MessageMobile from "@/components/device/MessageMobile.vue";
import EventRow from "@/components/device/EventRow.vue";
import EventRowMobile from "@/components/device/EventRowMobile.vue";

import moment from 'moment';
import tippy from 'tippy.js';

@Component({
  components:{
    VueError,
    Loading,
    MessageMobile,
    LoraWanUpdateView,
    CustomSectionHeader,
    EventRow,
    EventRowMobile
  }
})
export default class MessageSection extends Vue {

  @Prop({ default: () => [],  type: Array}) eventList!:DeviceEvent[];
  
  error:string = '';
  offset = 0;
  eventsPerPage = parseInt(process.env.VUE_APP_DEVICE_EVENTS_PER_PAGE!, 10);
  
  curEventList:DeviceEvent[] = [];
  
  async mounted() {
    this.offset = 0;
    this.refreshEventList();
  }

  refreshEventList() {
    this.curEventList = this.eventList.slice(this.offset, this.offset+this.eventsPerPage);
  }

  goBack() {
    this.offset+=this.eventsPerPage;
    this.refreshEventList();
  }

  goForward() {
    this.offset-=this.eventsPerPage;
    this.refreshEventList();
  }

  get showEventNav() {
    return this.eventList.length > this.eventsPerPage;
  }

  get showEventTable() {
    return this.eventList.length > 0;
  }

  get showNoEvents() {
    return this.eventList.length === 0;
  }

  get olderEventsEnabled() {
    return (this.offset + this.eventsPerPage) < this.eventList.length;
  }

  get newerEventsEnabled() {
    return this.offset > 0;
  }

}

